/**
 * Petit magasin « un appel est en cours » que la coquille lit pour retenir les pop-ups BETA (UX-17, PER-2 : jamais de
 * question BETA pendant un appel). La coquille branche `appelEnCours` dessus (RFC-L52-02).
 */
export interface MagasinAppel {
  debuter(): void;
  terminer(): void;
  enCours(): boolean;
  abonner(rappel: () => void): () => void;
}

export function creerMagasinAppel(): MagasinAppel {
  let enCours = false;
  const abonnes = new Set<() => void>();
  const changer = (valeur: boolean): void => {
    if (enCours === valeur) return;
    enCours = valeur;
    for (const rappel of [...abonnes]) rappel();
  };
  return {
    debuter: () => changer(true),
    terminer: () => changer(false),
    enCours: () => enCours,
    abonner(rappel) {
      abonnes.add(rappel);
      return () => void abonnes.delete(rappel);
    },
  };
}

export const magasinAppel: MagasinAppel = creerMagasinAppel();

/** Déclare l'appel en cours et rend la fonction qui le termine (appelée au démontage de l'écran M02). */
export function suivreAppel(magasin: MagasinAppel = magasinAppel): () => void {
  magasin.debuter();
  return () => magasin.terminer();
}
